var scope_0 = require('/var/www/elfehrest.com/html/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a8c9d7c3873a790bcbbcfe3e05ddcdb4.js').default;
var scope_1 = require('/var/www/elfehrest.com/html/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    